import React, { useState } from 'react';

import * as Styled from './styles.js';
import ContactForm from '../ContactForm';
import Projects from '../Projects/index.js';
import Skills from '../Skills/index.js';

export default function Header({ contactRef }) {
  const [showPopup, setShowPopup] = useState(false);

  function contactClicked() {
    setShowPopup(!showPopup);
  }

  function changeTab(index) {
    return () => {
      setTab(index)
    };
  }

  const [tab, setTab] = useState(0);
  const tabContents = [<Projects />, <Skills />];

  return (
    <Styled.Header>
      {showPopup && <ContactForm className="show" closePopup={contactClicked} />}
      <Styled.BackgroundPyramid />
      <Styled.Icons>
        <Styled.IconLink color="#11b2ee" target="_blank" href="https://www.linkedin.com/in/stephen-terrio-13163122b/"><i className="ri-linkedin-box-fill"></i></Styled.IconLink>
        <Styled.IconLink color="white" target="_blank" href="https://github.com/sterrio"><i className="ri-github-fill"></i></Styled.IconLink>
        <Styled.IconLink color="#e74d89" target="_blank" href="https://dribbble.com/sterrio"><i className="ri-dribbble-line"></i></Styled.IconLink>
      </Styled.Icons>
      <Styled.GlassBoxContainer>
        <Styled.GlassBox>
          <Styled.Name target="_blank" href="https://www.linkedin.com/in/stephen-terrio-13163122b/">@sterrio</Styled.Name>
          <Styled.Tag>Fullstack Developer</Styled.Tag>
          <Styled.Buttons>
            <Styled.Button cta href='Resume.pdf' download="Resume.pdf"><i className="ri-download-2-fill"></i>View Resume</Styled.Button>
            <Styled.Button sa onClick={contactClicked}>Contact<i className="ri-mail-send-fill"></i></Styled.Button>
          </Styled.Buttons>
          <Styled.AvatarBorder>
            <Styled.AvatarImage src="https://avatars.githubusercontent.com/u/18372712?v=4" />
          </Styled.AvatarBorder>
          <Styled.SlideDot />
          <Styled.Stats>
            <Styled.Stat target="_blank" href="https://github.com/sterrio">
              <h2>18</h2>
              <p>Personal<br />Projects</p>
            </Styled.Stat>
            <Styled.Stat target="_blank" href="https://www.linkedin.com/in/stephen-terrio-13163122b/">
              <h2>&nbsp;2+</h2>
              <p>Years <br /> Experience</p>
            </Styled.Stat>
            <Styled.Stat target="_blank" href="https://dribbble.com/sterrio">
              <h2>2</h2>
              <p>Dribbble<br />Shots</p>
            </Styled.Stat>
          </Styled.Stats>
        </Styled.GlassBox>
      </Styled.GlassBoxContainer>
      <Styled.MainDivide>
        <Styled.ButtonContainer>
          <Styled.NavButton onClick={changeTab(0)}>Projects</Styled.NavButton>
          <Styled.NavButton onClick={changeTab(1)}>Skills</Styled.NavButton>
        </Styled.ButtonContainer>
      </Styled.MainDivide>
      {tabContents[tab]}
      <Styled.Footer>Designed with ❤️ by Stephen Terrio</Styled.Footer>
    </Styled.Header>
  )
}
